import { gql, TypedDocumentNode } from "@apollo/client";

import { SearchSuggestionsOutput } from "types/generated";
import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

type SearchModulesSuggestionsData = {
  searchModulesSuggestions: SearchSuggestionsOutput;
};

export const GET_MODULES_SUGGESTIONS: TypedDocumentNode<SearchModulesSuggestionsData> = gql`
  query GetModuleSuggestionsNew($input: SearchSuggestionsInput!) {
    searchModulesSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
